import React from 'react';
import { LazyOrganizationsEdit } from '@atlassian/jira-issue-field-organizations/src/async.tsx';
import type { DefaultOrganizationData } from '@atlassian/jira-issue-field-organizations/src/common/types.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { FieldLoader } from '../../common/ui/field-loader/index.tsx';
import { FieldContainer } from '../../common/ui/fields/styled.tsx';
import { withFormField } from '../../common/ui/with-form-field/index.tsx';
import { closeMenuOnScroll } from '../../common/utils/select/index.tsx';
import { validateOrganizationsField } from '../../common/utils/validators/index.tsx';
import type { Props, OrganizationsFieldConfig, FieldValue } from './types.tsx';
import { mapDataToOrganizationOptions } from './utils.tsx';

const OrganizationsField = (props: Props) => {
	const {
		autoCompleteUrl,
		width,
		autoFocus = false,
		fieldProps: { value, onChange, ...fieldProps },
		onCloseMenuOnScroll = closeMenuOnScroll,
		isDropdownMenuFixedAndLayered = false,
		error,
	} = props;

	return (
		<FieldContainer width={width}>
			<Placeholder name="organizations-edit" fallback={<FieldLoader />}>
				<LazyOrganizationsEdit
					{...fieldProps}
					isInvalid={Boolean(error)}
					isDropdownMenuFixedAndLayered={isDropdownMenuFixedAndLayered}
					autoCompleteUrl={autoCompleteUrl}
					onChange={onChange}
					value={value}
					autoFocus={autoFocus}
					onCloseMenuOnScroll={onCloseMenuOnScroll}
					fetchSuggestionsOnFocus
				/>
			</Placeholder>
		</FieldContainer>
	);
};

export default withFormField<FieldValue, DefaultOrganizationData[]>({
	validator: validateOrganizationsField,
	transformDefaultValue: mapDataToOrganizationOptions,
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<OrganizationsFieldConfig, FieldValue>, any>'.
})<OrganizationsFieldConfig, FieldValue>(OrganizationsField);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { mutateOrganizationsField } from './utils';
